import { NavLink } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };


  return (
    <footer className="app-footer">
        <div className="footer-container">
          
          {/* Left column with navigation links */}
          <div className="footer-links">
            
            {/* SITEMAP */}
            <div className="column-group sitemap">
              <h3>Sitemap</h3>
              <NavLink to="/" onClick={scrollToTop} className="footer-link">Home</NavLink>
              <NavLink to="/find-plants" onClick={scrollToTop} className="footer-link">Find Plants</NavLink>
              <NavLink to="/dashboard" onClick={scrollToTop} className="footer-link">My Garden</NavLink>
              <NavLink to="/report" onClick={scrollToTop} className="footer-link">My Eco Impact</NavLink>
              <NavLink to="/ai-doctor" onClick={scrollToTop} className="footer-link">Plant Doctor</NavLink>
            </div>

            {/* ABOUT */}
            <div className="column-group about-yourgardenguru">
              <h3>About Us</h3>
              <NavLink to="/about" onClick={scrollToTop} className="footer-link">Our Mission</NavLink>
              <NavLink to="/contact" onClick={scrollToTop} className="footer-link">Contact</NavLink>
            </div>

            {/* CREDITS */}
            <div className="column-group citations">
              <h3>Image Credits</h3>
              <a href="https://ala.org.au" target="_blank" rel="noopener noreferrer" className="citation-link">Atlas of Living Australia</a>
              <a href="https://openai.com/chatgpt" target="_blank" rel="noopener noreferrer" className="citation-link">ChatGPT</a>
              <a href="https://www.flickr.com" target="_blank" rel="noopener noreferrer" className="citation-link">Flickr</a>
              <a href="https://pixabay.com" target="_blank" rel="noopener noreferrer" className="citation-link">Pixabay</a>
              <a href="https://www.pexels.com" target="_blank" rel="noopener noreferrer" className="citation-link">Pexels</a>
            </div>
          </div>

          {/* Right column with branding and copyright */}
          <div className="footer-branding">
            <NavLink to="/" onClick={scrollToTop} className="brand-link">
              <div className="brand-content">
                <h2 className="brand-name">
                  Your<span className="brand-highlight">Garden</span>Guru
                </h2>
                <p className="brand-tagline">Growing greener gardens together</p>
              </div>
            </NavLink>
            <p className="copyright">© {new Date().getFullYear()} YourGardenGuru. All rights reserved.</p>
          </div>

        </div>
      </footer>
  );
};

export default Footer;